import { useState, useRef, useContext } from 'react';
import { Form, Button, Typography, Flex, Input } from 'antd';
import CustomFormErrorMessage from '../../../components/CustomFormErrorMessage/CustomFormErrorMessage';
import LoginFormLayout from '../../../components/LoginFormLayout/LoginFormLayout';
import { useLocation, useNavigate } from 'react-router-dom';
import { ErrorMessageContext } from '../../../context/ErrorMessageContext';
import { LOGIN_TYPE_KEYS } from '../../../utilities/constants';
import PropTypes from 'prop-types';
const { Text } = Typography;

const OTPVerificationForm = ({ onValidateOTP, onResendOTP }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const otpRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;
  const { addErrorMessage } = useContext(ErrorMessageContext);

  const onFinish = async values => {
    try {
      setLoading(true);
      let { otp } = values;
      otp = otp.replaceAll(/\D/g, '').trim();
      await onValidateOTP(state?.email, state?.password, otp, setLoading);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('error: ', error);
    } finally {
      setLoading(false);
    }
  };

  const handleResendOTP = async () => {
    try {
      setLoading(true);
      await onResendOTP(state?.email, state?.password, setLoading);
      addErrorMessage(
        'OTP re-sent to your registered mobile number.',
        'success'
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('error: ', error);
    } finally {
      setLoading(false);
      otpRef.current?.focus();
    }
  };

  const handleBack = () => {
    form.resetFields();
    navigate('/login', {
      state: {
        stepType: LOGIN_TYPE_KEYS.MFA,
        email: state?.email,
      },
    });
  };

  return (
    <LoginFormLayout
      onFinish={onFinish}
      title={'Verify OTP'}
      type="otp-verification"
      showBackButton={true}
      form={form}
      onBack={handleBack}
    >
      <Flex className="full-width register-link" align="center">
        <Text style={{ paddingBottom: 24 }}>
          {`Hello, ${state?.email || ''}`} <br />
          Please enter the OTP sent to your registered mobile number in order to
          proceed
        </Text>
      </Flex>
      <Form.Item
        name="otp"
        rules={[
          {
            required: true,
            message: <CustomFormErrorMessage message="Please enter otp" />,
          },
        ]}
        className="full-width register-link"
      >
        <Input.OTP length={6} size="large" autoFocus ref={otpRef} />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" block loading={loading}>
          Login
        </Button>
      </Form.Item>

      <Flex
        className="full-width register-link"
        gap={5}
        align="center"
        justify="center"
      >
        Didn&#39;t receive the OTP?
        <Button
          type="link"
          className="btn-login-link"
          onClick={() => handleResendOTP()}
        >
          Resend OTP
        </Button>
      </Flex>
    </LoginFormLayout>
  );
};

OTPVerificationForm.propTypes = {
  onValidateOTP: PropTypes.func.isRequired,
  onResendOTP: PropTypes.func.isRequired,
};
export default OTPVerificationForm;
